module.exports = "<div class=\"footer-copyright -{{ options?.page }}\">\n  <div class=\"copyright-inner\">©Copyright 2016-{{currentDate | date: 'yyyy'}} www.ascendtravel.com <span class=\"hide-sm\">-</span> All rights reserved</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer-copyright/footer-copyright.component.html
// module id = 1028
// module chunks = 22